module.exports = __webpack_public_path__ + "static/img/nodata.95dbe4d8.jpg";